// extracted by mini-css-extract-plugin
export var link = "_sv-0";